import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { useCart } from '../../context/CartContext';

const ArtozphereCartBar = () => {
  const { cartItems } = useCart();
  const count = cartItems.length;

  return (
    <Link
      to="/artozphere/cart"
      className="relative inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-800 shadow-sm hover:bg-gray-50 transition-colors"
      aria-label={`Shopping cart${count ? `, ${count} items` : ''}`}
    >
      <FontAwesomeIcon icon={faShoppingCart} className="h-4 w-4" />
      <span>Cart</span>
      {count > 0 && (
        <span className="absolute -right-1 -top-1 flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-green-600 px-1 text-xs font-bold text-white">
          {count}
        </span>
      )}
    </Link>
  );
};

export default ArtozphereCartBar;
